export default "__VITE_ASSET__CwVTbUp2__"